// Length units data for conversion routes
export const lengthUnits = [
  { id: 'meter', name: 'Meter', symbol: 'm', plural: 'Meters', factor: 1 },
  { id: 'kilometer', name: 'Kilometer', symbol: 'km', plural: 'Kilometers', factor: 1000 },
  { id: 'centimeter', name: 'Centimeter', symbol: 'cm', plural: 'Centimeters', factor: 0.01 },
  { id: 'millimeter', name: 'Millimeter', symbol: 'mm', plural: 'Millimeters', factor: 0.001 },
  { id: 'micrometer', name: 'Micrometer', symbol: 'μm', plural: 'Micrometers', factor: 0.000001 },
  { id: 'nanometer', name: 'Nanometer', symbol: 'nm', plural: 'Nanometers', factor: 0.000000001 },
  { id: 'mile', name: 'Mile', symbol: 'mi', plural: 'Miles', factor: 1609.344 },
  { id: 'yard', name: 'Yard', symbol: 'yd', plural: 'Yards', factor: 0.9144 },
  { id: 'foot', name: 'Foot', symbol: 'ft', plural: 'Feet', factor: 0.3048 },
  { id: 'inch', name: 'Inch', symbol: 'in', plural: 'Inches', factor: 0.0254 },
  { id: 'nautical-mile', name: 'Nautical Mile', symbol: 'nmi', plural: 'Nautical Miles', factor: 1852 },
];

// Popular conversions matching unitconverters.net
export const popularLengthConversions = [
  { from: 'centimeter', to: 'inch' },
  { from: 'inch', to: 'centimeter' },
  { from: 'millimeter', to: 'inch' },
  { from: 'inch', to: 'millimeter' },
  { from: 'meter', to: 'foot' },
  { from: 'foot', to: 'meter' },
  { from: 'kilometer', to: 'mile' },
  { from: 'mile', to: 'kilometer' },
  { from: 'centimeter', to: 'foot' },
  { from: 'foot', to: 'centimeter' },
  { from: 'meter', to: 'yard' },
  { from: 'yard', to: 'meter' },
  { from: 'foot', to: 'inch' },
  { from: 'inch', to: 'foot' },
  { from: 'millimeter', to: 'centimeter' },
  { from: 'centimeter', to: 'millimeter' },
  { from: 'meter', to: 'centimeter' },
  { from: 'centimeter', to: 'meter' },
  { from: 'meter', to: 'kilometer' },
  { from: 'kilometer', to: 'meter' },
  { from: 'yard', to: 'foot' },
  { from: 'foot', to: 'yard' },
  { from: 'nautical-mile', to: 'kilometer' },
  { from: 'kilometer', to: 'nautical-mile' },
  { from: 'mile', to: 'foot' },
  { from: 'foot', to: 'mile' },
  { from: 'meter', to: 'inch' },
  { from: 'inch', to: 'meter' },
  { from: 'yard', to: 'inch' },
  { from: 'inch', to: 'yard' },
];

// Generate all possible conversion pairs
export const generateAllLengthConversions = () => {
  const conversions = [];
  for (const fromUnit of lengthUnits) {
    for (const toUnit of lengthUnits) {
      if (fromUnit.id !== toUnit.id) {
        conversions.push({
          from: fromUnit.id,
          to: toUnit.id,
          fromUnit,
          toUnit,
          slug: `${fromUnit.id}-to-${toUnit.id}`,
        });
      }
    }
  }
  return conversions;
};

// Get unit by ID
export const getUnitById = (id) => {
  return lengthUnits.find(unit => unit.id === id);
};

// Convert between units
export const convertLength = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;

  // Convert to meters first, then to target unit
  const meters = value * fromUnit.factor;
  return meters / toUnit.factor;
};

// Format conversion slug to readable text
export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

// Generate SEO description
export const generateSEODescription = (fromUnit, toUnit) => {
  const sampleValue = 1;
  const result = convertLength(sampleValue, fromUnit.id, toUnit.id);
  const formattedResult = result < 0.001 || result > 1000000
    ? result.toExponential(4)
    : result.toPrecision(6).replace(/\.?0+$/, '');

  return `Convert ${fromUnit.plural} to ${toUnit.plural}. 1 ${fromUnit.name} = ${formattedResult} ${toUnit.plural}. Free online length unit converter.`;
};
